import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function NetworkWarning({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M16.0002 3H19.2802C20.2202 3 20.9902 3.76 20.9902 4.71V7.99M8.00023 21H4.71023C3.76023 21 2.99023 20.23 2.99023 19.28V15.99M16.9502 16.42V14.58M16.9512 18.44C16.9012 18.44 16.8512 18.48 16.8612 18.53C16.8612 18.58 16.9012 18.62 16.9512 18.62C17.0012 18.62 17.0412 18.57 17.0412 18.52C17.0412 18.47 16.9912 18.42 16.9412 18.42M18.6952 12.6L21.7352 18.014C22.4752 19.344 21.5152 20.994 19.9852 20.994H13.8852C12.3552 20.994 11.3852 19.344 12.1352 18.004L15.1752 12.584C15.9352 11.225 17.8952 11.225 18.6552 12.584L18.6952 12.6ZM5.16023 5.035C3.94023 5.195 2.99823 6.235 2.99823 7.5C2.99823 8.88 4.11823 10 5.49823 10H10.9982C12.0982 10 12.9982 9.1 12.9982 8C12.9982 6.89 12.0982 6 10.9982 6C10.9982 4.343 9.65523 3 7.99823 3C6.67823 3 5.56223 3.85 5.15823 5.035H5.16023Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default NetworkWarning;